import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

// Solo probamos atoms por ahora para verificar funcionamiento básico
import { 
  SuraButtonComponent, 
  ButtonConfig
} from '@sura-ui/atoms';

@Component({
  selector: 'app-simple-test',
  standalone: true,
  imports: [
    CommonModule,
    SuraButtonComponent
  ],
  template: `
    <div class="p-8 text-center">
      <h1 class="text-2xl font-bold mb-6">🧪 Prueba Simple de &#64;sura-ui</h1>
      
      <div class="mb-4 p-4 border rounded">
        <h2 class="text-lg mb-3">⚛️ Atom: SuraButtonComponent</h2>
        <sura-button 
          [config]="buttonConfig" 
          (buttonClick)="onButtonClick($event)">
        </sura-button>
      </div>
      
      <div class="bg-green-100 p-4 rounded">
        <p class="text-green-800 font-semibold">✅ Si ves este botón, la librería unificada funciona!</p>
      </div>
    </div>
  `
})
export class SimpleTestComponent {
  
  buttonConfig: ButtonConfig = {
    id: 'simple-test-btn',
    label: '🎯 ¡Funciona!',
    variant: 'primary',
    size: 'large'
  };
  
  constructor() {
    console.log('🧪 Prueba simple iniciada');
    console.log('✅ SuraButtonComponent importado desde &#64;sura-ui/atoms');
  }
  
  onButtonClick(event: Event): void {
    console.log('🔥 ¡Button clicked! La librería funciona:', event);
    alert('🎉 ¡La librería unificada &#64;sura-ui funciona perfectamente!');
  }
}